import emailjs from "functions/emailConfig";
import arrow from "assets/icons/arrow.svg";
import Image from "assets/png/contact.png";
import Swal from "sweetalert2";
import "./contact.css";
import { useState } from "react";

const Contact = () => {
  const [name, setName] = useState("");
  const [call, setCall] = useState("");
  const [email, setEmail] = useState("");
  const [number, setNumber] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();
    setLoading(true);

    emailjs
      .send("service_580z1hh", "template_0pt04pn", {
        email,
        message,
        name,
        number,
        call,
      })
      .then(
        (response) => {
          Swal.fire({
            icon: "success",
            title: "Message Sent Successfully",
          });
          setLoading(false);
          setEmail("");
          setName("");
          setMessage("");
          setNumber("");
          console.log(response);
        },
        (error) => {
          Swal.fire({
            icon: "error",
            title: "An error occured",
          });
          console.error("Email send failed:", error);
        }
      );
  };

  return (
    <div id="contact">
      <div className="three bg-gray flex flex-col items-center py-16 gap-10">
        <div className="three-block">
          <p className="subtitle gray pry-text center">CONTACT US</p>
          <p className="header black pry-text center">
            Get in Touch
          </p>
        </div>

        <div className="section-grid-2 shift-up grid lg:grid-cols-2 lg:px-20 ">
          <img
            src={Image}
            alt=""
            className="section-img cont-img w-full rounded-xl lg:h-[600px]"
          />

          <form className="findform pry-text items-start" onSubmit={sendEmail}>
            <label htmlFor="name" className="w-full">
              Full Name
              <input
                type="text"
                name="name"
                placeholder="Telematics"
                className="pry-text input-txt"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </label>

            <label htmlFor="email" className="w-full">
              Email Address
              <input
                type="email"
                name="email"
                placeholder="telematics@gmail.com"
                className="pry-text input-txt"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </label>

            <label htmlFor="number" className="w-full">
              Contact number
              <input
                type="text"
                name="number"
                placeholder="08012345678"
                className="pry-text input-txt"
                value={number}
                onChange={(e) => setNumber(e.target.value)}
                required
              />
            </label>

            <label htmlFor="number" className="w-full">
              Preferrable Time to Call
              <input
                type="text"
                name="call"
                placeholder="12:00pm"
                className="pry-text input-txt"
                value={call}
                onChange={(e) => setCall(e.target.value)}
                required
              />
            </label>

            <label htmlFor="message" className="w-full">
              Message
              <textarea
                name="message"
                id="message"
                className="pry-text input-txt"
                placeholder="Request for a proposal"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                required
              ></textarea>
            </label>

            <button
              className="button form-btn flex gap-4 bg-blue-100 py-4 px-8"
              type="submit"
            >
              {loading ? (
                <p className="sec-text white">Sending...</p>
              ) : (
                <>
                  <p className="sec-text white">Send</p>
                  <img src={arrow} alt="" />{" "}
                </>
              )}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contact;
